import { useSelector } from "react-redux";
import { State } from "~/store";
import { NavigationMap } from "~/store/navigation";

export default function useNavigation() {
  return useSelector<State, NavigationMap | undefined>(
    (state) => state.navigation.navigation
  );
}
